import {
  AlphabetCollectionsDraftApi,
  SharedserviceMelcoModelsAlphabetCollection,
  useAPIQuery,
  useTable,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";

import { useTableErrorComponent } from "../../table/useTableErrorComponent";
import {
  ALL_PUBLISHED_STATES,
  PublishState,
} from "../../../helper/publishedState";

export const useFontCollections = (publishedState?: PublishState) => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<SharedserviceMelcoModelsAlphabetCollection>();

  const publishState = publishedState ?? ALL_PUBLISHED_STATES;

  const query = useAPIQuery(
    AlphabetCollectionsDraftApi,
    ["fontCollections", currentPage, pageSize, filters, sortBy(), searchQuery],
    async (api) => {
      const response = await api.userAlphabetCollectionsGetList({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        publishState,
        searchText: !isEmpty(searchQuery) ? searchQuery : undefined,
      });

      setTotal(response.total);

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,
    ...query,
  };
};
